import inherited from 'mastodon/locales/zh-CN.json';

const messages = {
  //  No translations available.
};

export default Object.assign({}, inherited, messages);
